import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=122ee5f2&"
import script from "./userReport.vue?vue&type=script&lang=js&"
export * from "./userReport.vue?vue&type=script&lang=js&"
import style0 from "./userReport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports